define.alias("shared/components/shared/post/secondary/caption-writer/body", "settings/components/shared/post/secondary/caption-writer/body");